import React, { useState, useEffect, useCallback } from 'react';
import { subscribe } from 'lib/EventBuser';
import { listSenders } from 'services/SenderService';
import SenderFormModal from '../../SenderFormModal';
import SendersTable from './SendersTable';
import { OPEN_CREATE_SENDER_MODAL } from './constants';

function SendersSettings() {
    const [senders, setSenders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    const fetchSenders = useCallback(() => {
        setLoading(true);
        return listSenders()
            .then((data) => {
                setSenders(data);
            })
            .catch((error) => {
                console.error('Error fetching senders:', error);
                setSenders([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        fetchSenders();
    }, [fetchSenders]);

    const handleOpenCreateModal = useCallback(() => {
        setIsCreateModalOpen(true);
    }, []);

    const handleCloseCreateModal = useCallback(() => {
        setIsCreateModalOpen(false);
    }, []);

    const handleCreateSuccess = useCallback(() => {
        fetchSenders();
        handleCloseCreateModal();
    }, [fetchSenders, handleCloseCreateModal]);

    useEffect(() => {
        const unsubscribe = subscribe(OPEN_CREATE_SENDER_MODAL, handleOpenCreateModal);
        return unsubscribe;
    }, [handleOpenCreateModal]);

    return (
        <div className="marketing-settings__senders">
            <SendersTable senders={senders} loading={loading} onRefresh={fetchSenders} />
            <SenderFormModal
                isOpen={isCreateModalOpen}
                onCancel={handleCloseCreateModal}
                onRequestClose={handleCloseCreateModal}
                onSuccess={handleCreateSuccess}
            />
        </div>
    );
}

SendersSettings.displayName = 'SendersSettings';

export default SendersSettings;
